module.exports = __webpack_public_path__ + "img/ic-drop-down.7b09d5b0.svg";